/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ quarter: NonNullable<unknown> }} Partner_Payout_Customers_InInputs */



/**
* | output |
* | --- |
* | "Customers · {quarter}" |
*
* @param {Partner_Payout_Customers_InInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_payout_customers_in = /** @type {((inputs: Partner_Payout_Customers_InInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Payout_Customers_InInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Kunden · ${i?.quarter}`)
	return /** @type {LocalizedString} */ (`Customers · ${i?.quarter}`)
});